<template>
  <div>
    <h4 class="spec-title">
      {{ title }}
    </h4>
    <ul class="specs-list row">
      <li
        v-for="(detail, index) in details"
        v-show="index + 1 <= itemLimit || showMore"
        :key="index"
        class="equipment-item col-6"
      >
        {{ detail }}
      </li>
    </ul>
    <button v-if="details.length > itemLimit" @click="showMore = !showMore" class="show-more">
      <i :class="{ 'rotate-up': showMore }" class="fas fa-angle-down" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'VehicleSpecificationsDetails',
  props: {
    details: {
      type: Array,
      required: true,
    },
    itemLimit: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showMore: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.show-more {
  align-items: center;
  border: 2px solid #007bff;
  border-radius: 100%;
  display: flex;
  height: 24px;
  justify-content: center;
  margin: auto;
  padding: 0;
  width: 24px;

  i.fas {
    color: #007bff;
    float: none;
    font-size: 18px;
    margin: 0;
    transition: transform 350ms;
  }

  .rotate-up {
    transform: scaleY(-1);
  }
}
</style>
